export const UNKNOWN_CRITICAL_TIME_FIELDS = [
  'pushingStart', 'crowning', 'headBornTime', 'buttocksVisible', 'buttocksBorn',
  'trunkToUmbilicus', 'armsDelivered', 'headVisible'
];
export const UNKNOWN_INTERVAL = 'Unavailable — time unknown';
export const getUnknownCriticalTimes = (event = {}) => {
  const fields = event?.unknownCriticalTimes ?? event?.UnknownCriticalTimes;
  return Array.isArray(fields)
    ? [...new Set(fields.filter(field => UNKNOWN_CRITICAL_TIME_FIELDS.includes(field)))]
    : [];
};
export const isCriticalTimeUnknown = (event, field) => getUnknownCriticalTimes(event).includes(field);

// Apply the timestamp and status in one state update; never infer a timestamp.
export const getCriticalTimeChangePatch = (event, target) => {
  const patch = { [target.name]: target.value };
  if (!UNKNOWN_CRITICAL_TIME_FIELDS.includes(target.name)) return patch;
  const unknown = getUnknownCriticalTimes(event).filter(field => field !== target.name);
  if (target.timeUnknown === true) unknown.push(target.name);
  patch.unknownCriticalTimes = unknown;
  if (target.timeUnknown !== undefined) patch[target.name] = null;
  if (target.name === 'pushingStart') patch.pushingDuration = null;
  return patch;
};

export const normalizeUnknownCriticalTimes = (event = {}) => {
  const result = { ...event, unknownCriticalTimes: getUnknownCriticalTimes(event) };
  delete result.UnknownCriticalTimes;
  for (const field of result.unknownCriticalTimes) {
    result[field] = null;
    delete result[field[0].toUpperCase() + field.slice(1)];
    for (const nested of ['criticalTimes', 'CriticalTimes', 'breechTimes', 'BreechTimes']) {
      if (result[nested]) result[nested] = {
        ...result[nested], [field]: null, [field[0].toUpperCase() + field.slice(1)]: null
      };
    }
  }
  if (result.unknownCriticalTimes.includes('pushingStart')) {
    result.pushingDuration = null;
    delete result.PushingDuration;
  }
  return result;
};
